var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchoolShalaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 319,
    viewBox: "0 0 261 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M242.5 206C242.5 201.582 238.918 198 234.5 198H219H41H26.5C22.0817 198 18.5 201.582 18.5 206V311C18.5 315.418 22.0817 319 26.5 319H90C92.2091 319 94 317.209 94 315V263.25C94 243.23 110.23 227 130.25 227C150.27 227 166.5 243.23 166.5 263.25V315C166.5 317.209 168.291 319 170.5 319H234.5C238.918 319 242.5 315.418 242.5 311V206Z",
    fill: "#FFB39D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.77 22.4966C171.63 22.5037 169.549 21.8847 167.604 20.9937C159.201 17.1447 147.6 15.9846 136 20C133.509 15.0179 126 16.7905 126 22.3607V79L21.545 149.88C15.0233 154.306 18.1556 164.5 26.037 164.5H41V198H219V164.5H234.792C242.688 164.5 245.81 154.274 239.26 149.864L134 79V58.5C135.448 56.6381 138.831 55.4985 142.406 54.832C148.347 53.7243 154.371 55.2399 160.142 57.0333C182.727 64.0512 187.866 57.5821 191 54V19C188.298 22.152 183.164 22.4654 173.77 22.4966Z",
    fill: "#FA6B63"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 160,
    r: 25,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolShalaLogo);
export default __webpack_public_path__ + "static/media/school_shala_logo.a368a8ebbc3b1f0f1ae2a4f0c09d1da0.svg";
export { ForwardRef as ReactComponent };